import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Globe } from 'lucide-react';

export const LanguageSelector = ({ className = '', showLabel = false }) => {
  const { currentLanguage, changeLanguage, languages, t } = useLanguage();

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {showLabel && <Globe className="w-4 h-4 text-slate-500" />}
      <Select value={currentLanguage} onValueChange={changeLanguage}>
        <SelectTrigger
          className="w-[140px]"
          aria-label={t('common.language')}
          title={t('common.language')}
          data-testid="language-selector"
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {languages.map((lang) => (
            <SelectItem key={lang.code} value={lang.code}>
              <span className="flex items-center gap-2">
                <span>{lang.flag}</span>
                <span>{lang.name}</span>
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default LanguageSelector;
